import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PropsWithChildren } from 'react'

import { cn } from 'utils/cn'

type Props = {
  variant?: 'low' | 'medium' | 'high' | 'neutral'
}

export const RiskIndicator = ({ variant, children }: PropsWithChildren<Props>) => {
  const isNeutral = !variant || variant === 'neutral'

  return (
    <div className="flex h-full items-center">
      <span
        className={cn(
          'kui-subheading rounded-full flex items-center px-2 py-0.75 box-border w-fit bg-default border-default border whitespace-nowrap',
          {
            'bg-success text-success border-none': variant === 'low',
            'bg-critical !text-critical border-none': variant === 'medium',
            'bg-danger text-danger border-none': variant === 'high',
          },
        )}
      >
        {isNeutral
          ? (
              <FontAwesomeIcon icon={faCheck} size="sm" className="mb-0.5 mr-2" />
            )
          : (
              <span
                className={cn('mr-2 size-2 rounded-full bg-grey-70', {
                  'bg-green-60': variant === 'low',
                  'bg-amber-50': variant === 'medium',
                  'bg-red-70': variant === 'high',
                })}
              />
            )}
        {children}
      </span>
    </div>
  )
}
